module.exports = __webpack_public_path__ + "img/c_bike.97e3562d.svg";